import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceService } from 'src/app/services/api-service.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss'
})
export class ForgetPasswordComponent {

   email = '';
  message = '';
  error = '';
   token = '';
  newPassword = '';
  constructor(private api: ApiServiceService ,private route: ActivatedRoute) {
    this.token = this.route.snapshot.paramMap.get('token') || '';
  }
 
  onSubmit() {
    this.message = 'Sending reset link...';
    this.error = '';

    this.api.forgotPassword(this.email).subscribe({
      next: (res) => {
        this.message = res.message;
        this.email = ''; // clear email field
        
      },
      error: (err) => {
        this.error = err.error?.message || 'Something went wrong';
        this.message = '';
      }
    });
  }

  passwordSave() {
    this.api.resetPassword(this.token, this.newPassword).subscribe({
      next: (res) => {this.message = res.message,
       this.newPassword = ''; 
      },
      error: (err) => this.error = err.error?.message || 'Something went wrong'
    });
  }
}
